import { FC } from 'react';

export const EyeSvg: FC = () => {
    return (
        <svg width={16} height={16} fill='none'>
            <g stroke='#193364' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M8 10.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334Z' />
                <path d='M14.667 8c-1.147 2.52-3.52 5.333-6.667 5.333S2.48 10.52 1.333 8C2.48 5.48 4.853 2.667 8 2.667S13.52 5.48 14.667 8Z' />
            </g>
            <defs>
                <clipPath id='a'>
                    <path fill='#fff' d='M0 0h16v16H0z' />
                </clipPath>
            </defs>
        </svg>
    );
};